import React from "react";
import { TouchableOpacity } from "react-native";
import Svg, { Path, Defs, Rect, G, ClipPath } from "react-native-svg";
import { uniqueId } from "lodash";

export default function TrashIcon(props) {
  const width = props.width || 15;
  const height = props.height || 14;

  const filterId = "clip0_trash" + uniqueId();
  const filterUrl = `url(#${filterId})`;

  return (
    <TouchableOpacity style={props.style} {...props}>
      <Svg
        width={width}
        height={height}
        viewBox="0 0 15 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <G clipPath={filterUrl}>
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.2499 3.1499H12.0499C12.1427 3.1499 12.2318 3.18678 12.2974 3.25242C12.363 3.31805 12.3999 3.40708 12.3999 3.4999C12.3999 3.59273 12.363 3.68175 12.2974 3.74739C12.2318 3.81303 12.1427 3.8499 12.0499 3.8499H2.2499C2.15708 3.8499 2.06805 3.81303 2.00241 3.74739C1.93678 3.68175 1.8999 3.59273 1.8999 3.4999C1.8999 3.40708 1.93678 3.31805 2.00241 3.25242C2.06805 3.18678 2.15708 3.1499 2.2499 3.1499H5.0499V1.7499C5.0499 1.65708 5.08678 1.56805 5.15241 1.50241C5.21805 1.43678 5.30708 1.3999 5.3999 1.3999H8.8999C8.99273 1.3999 9.08175 1.43678 9.14739 1.50241C9.21303 1.56805 9.2499 1.65708 9.2499 1.7499V3.1499ZM8.5499 2.0999H5.7499V3.1499H8.5499V2.0999Z"
            fill="#DD5F43"
          />
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2.9499 11.1999V4.5499H11.3499V11.1999C11.3499 11.5712 11.2024 11.9273 10.9399 12.1899C10.6773 12.4524 10.3212 12.5999 9.9499 12.5999H4.3499C3.9786 12.5999 3.6225 12.4524 3.35995 12.1899C3.0974 11.9273 2.9499 11.5712 2.9499 11.1999ZM8.5499 10.4698L9.0448 9.9749L7.6448 8.5749L9.0448 7.1749L8.5499 6.68L7.1499 8.08L5.7499 6.68L5.255 7.1749L6.655 8.5749L5.255 9.9749L5.7499 10.4698L7.1499 9.0698L8.5499 10.4698Z"
            fill="#DD5F43"
          />
        </G>
        <Defs>
          <ClipPath id={filterId}>
            <Rect
              width="11.2"
              height="11.2"
              fill="white"
              transform="translate(1.8999 1.3999)"
            />
          </ClipPath>
        </Defs>
      </Svg>
    </TouchableOpacity>
  );
}
